export enum Routes {
  HomeRouter = '*',
  HomePage = '*',
  DashboardPage = '/dashboard',
  FlowPage = '/flow',
}
